import React from "react";
import { ButtonComponentHolderMainDiv } from "../../../../../styles/reusable/buttonstyles/buttonstyles";

interface ButtonComponentInterface {
  link?: string;
  onclick?: () => void;
  icon?:any;
  title: string;
}
const ButtonComponent = ({
  link,
  onclick,
  icon,
  title,
}: ButtonComponentInterface) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onclick) {
      e.preventDefault();
      onclick();
    }
  };

  return (
      <ButtonComponentHolderMainDiv>
        <a href={link??"/"} onClick={handleClick}>
          <div className="circle" />
          <div className="top-blur" />
          <div className="radial-gradient" />
          <div className="inset" />
          <div className="button-holder">
            <div className="button-label">
              <div >
              {icon?icon:""}

              </div>
              <p className="button-label-text">{title}</p>
            </div>
            <div className="button-label-2">
              <div >
              {icon?icon:""}

              </div>
              <p className="button-label-text">{title} </p>
            </div>
          </div>
        </a>
      </ButtonComponentHolderMainDiv>
    
  );
};

export default ButtonComponent;

